const CardTag = ({ tag, isProjectAccessible }) => {
  return (
    <div
      className={`flex items-center justify-center h-[22px] px-[8px] leading-[10px] rounded-full bg-white text-xs font-normal border ${
        tag.licenseExpired && !isProjectAccessible
          ? "text-[#EA7565] border-[#EA7565]"
          : "text-gray-400 border-gray-400"
      }`}
    >
      <span className="mt-[1px] whitespace-nowrap">{tag.text}</span>
    </div>
  );
};

export default CardTag;
